import { connect } from '@atlassian/jira-react-redux';
import { getIsReleasesFeatureEnabled } from '../../../../../state/configuration/selectors';
import type { State } from '../../../../../state/types';
import Skeleton from './view';

export default connect(
	(state: State) => ({ isReleasesFeatureEnabled: getIsReleasesFeatureEnabled(state) }),
	{},
)(Skeleton);
